import { FC, Fragment, TextareaHTMLAttributes } from "react";

export type TextAreaHintProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label: string;
  htmlFor?: string;
  spanMessage?: string;
};

export const TextAreaHint: FC<TextAreaHintProps> = ({
  label,
  htmlFor,
  spanMessage,
  ...props
}) => {
  return (
    <Fragment>
      <div>
        <div className="flex justify-between">
          <label
            htmlFor={htmlFor}
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            {label}
          </label>
          <span className="text-sm leading-6 text-gray-500">{spanMessage}</span>
        </div>
        <div>
          <textarea
            {...props}
            className="block w-full rounded-md border-0 py-1.5 text-gray-600 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6 resize-none"
          />
        </div>
      </div>
    </Fragment>
  );
};
